import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useCustomerEvents } from '@/modules/Customer/hooks/use-customer-events'
import { paths } from '@/utils/path'

// Lịch sự kiện khách hàng — màn hình chỉ-đọc, tự lọc theo người đang đăng nhập.
//
// Backend quyết phạm vi: BOD/BOM/Leader/Admin thấy toàn bộ, sale/CS chỉ thấy khách mình
// theo dõi, người không theo dõi ai nhận danh sách rỗng + HTTP 200. Frontend KHÔNG lọc lại,
// cũng không gate theo phòng ban (khác MyIncomes) — làm thế sẽ thu hẹp thêm một lần nữa.
const CustomerEvents = () => {
    const {
        t,
        page,
        pageSize,
        events,
        total,
        columns,
        stateComponent,
        isFetching,
        handlePageChange,
        handlePageSizeChange,
        filterControl,
        filterItems,
    } = useCustomerEvents()

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.account,
                        title: t('calendar_events.account'),
                    },
                    { path: '', title: t('calendar_events.title') },
                ]}
            />

            <Paper>
                <div className="mb-2 flex justify-end">
                    <p className="text-sm text-gray-500">
                        {t('calendar_events.summary', { total })}
                    </p>
                </div>
                <FilterBar
                    control={filterControl}
                    items={filterItems}
                    hideSearch
                />

                {/* Không early-return trên stateComponent: nếu return sớm thì lỗi API sẽ xoá
                    luôn ô chọn tháng, người dùng mất đường thoát khỏi tháng đang lỗi. */}
                {stateComponent ? (
                    stateComponent
                ) : events.length === 0 ? (
                    <p className="py-10 text-center text-sm text-gray-400">
                        {t('calendar_events.empty')}
                    </p>
                ) : (
                    <DataTableCustomized
                        columns={columns}
                        rows={events}
                        rowKey={(row) => `${row.event_type}-${row.customer_id}`}
                        size="small"
                        loading={isFetching}
                        pagination={{
                            page,
                            pageSize,
                            total,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default CustomerEvents
